import { render, staticRenderFns } from "./head_top.vue?vue&type=template&id=55707004&scoped=true&"
import script from "./head_top.vue?vue&type=script&lang=js&"
export * from "./head_top.vue?vue&type=script&lang=js&"
import style0 from "./head_top.vue?vue&type=style&index=0&id=55707004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55707004",
  null
  
)

export default component.exports